import { useEffect } from "react";
export const BarChartTheme=(props)=>{
  
   useEffect(()=>{
    window.Chart.defaults.font.family = window.app.font.family;
    window.Chart.defaults.color = 'white';
    window.Chart.defaults.plugins.legend.position = 'bottom';
    window.Chart.defaults.plugins.tooltip.backgroundColor = 'rgba('+ window.app.color.gray800Rgb +', .95)';
    window.Chart.defaults.plugins.tooltip.titleFont.family = window.app.font.family;
    window.Chart.defaults.plugins.tooltip.titleFont.weight = 600;
    window.Chart.defaults.plugins.tooltip.footerFont.family = window.app.font.family;
    window.Chart.defaults.scale.grid.color = 'rgba('+ window.app.color.whiteRgb +', .25)';
    // window.Chart.defaults.scale.ticks.backdropColor = 'rgba('+ window.app.color.whiteRgb +', .2)' +', 0)';
    let ctx = document.getElementById(props.id);
    ctx.height = 120;
    if(props.height){
     ctx.height=props.height
    }
    let lineChart = new window.Chart(ctx, {
    type: 'bar',
    data: {
      labels: props.categories,
      options: {  
        responsive: true,
        maintainAspectRatio: false
    },
    datasets: [
    {
      label: "Enter Count",
      data: props.data,
      backgroundColor: 'rgba('+ window.app.color.themeRgb +', .2)',
      borderColor: window.app.color.theme,
      borderWidth: 1.0
    },
    {
      label: "Exit Count",
      data: props.exitData,
      backgroundColor: 'rgba(255, 0, 0, 0.2)', // Red color for exit count
      borderColor: 'rgba(255, 0, 0, 1)', // Red border color
      borderWidth: 1.0
    }
  ]
    }
    
   });
   return ()=>{
    lineChart.destroy()
   }
   }
  ,[props.data])
       

  return (
    <>
    
    <canvas id={props.id}/>
    
    </>

    
  )
}